export default class Signal {
  #subscriptions = new Set();

  add(callback) {
    this.#subscriptions.add(callback);
  }
  dispatch(...args) {
    for (const cb of [...this.#subscriptions]) cb(...args);
  }
  remove(callback) {
    this.#subscriptions.delete(callback);
  }
  clear() {
    this.#subscriptions.clear();
  }
  /**
   * Listen for signal dispatches and return a cleanup function
   * @param {Function} callback - Callback function to execute when signal is dispatched
   * @returns {Function} Cleanup function to remove the listener
   */
  on(callback) {
    this.add(callback);
    return () => this.remove(callback);
  }
}
